export default __webpack_public_path__ + "static/media/background_treework.27c88f03.jpg";